<div class="container-fluid maintainer-console">
  <h3 class="mt-3 mb-3">Consola de mantenimiento</h3>

  <div class="mt-3">
          <!-- Filtros -->
          <div class="filters">
            <div class="form-group">
              <label class="sr-only" for="filterSearch">Buscar por correo, guid o nombre</label>
              <input id="filterSearch" type="text" class="form-control" placeholder="Buscar correo | guid | nombre" aria-label="Buscar por correo, guid o nombre" (input)="onSearchChange($event.target.value)">
            </div>
            <div class="form-group" style="max-width:160px">
              <label class="sr-only" for="filterStatus">Estado</label>
              <select id="filterStatus" class="form-control" aria-label="Filtrar por estado" [(ngModel)]="statusFilter" (change)="onFilterChange()">
                <option value="">Todos los estados</option>
                <option value="TRIAL">TRIAL</option>
                <option value="ACTIVE">ACTIVE</option>
                <option value="EXPIRED">EXPIRED</option>
                <option value="LIFETIME">LIFETIME</option>
              </select>
            </div>
            <div class="form-group" style="max-width:160px">
              <label class="sr-only" for="filterProvider">Medio de pago</label>
              <select id="filterProvider" class="form-control" aria-label="Filtrar por medio de pago" [(ngModel)]="providerFilter" (change)="onFilterChange()">
                <option value="">Todos los medios de pago</option>
                <option value="paypal">paypal</option>
                <option value="manual">manual</option>
                <option value="mercadopago">mercadopago</option>
                <option value="stripe">stripe</option>
              </select>
            </div>
            <div class="form-group" style="max-width:150px">
              <label class="sr-only" for="filterBilling">Facturación</label>
              <select id="filterBilling" class="form-control" aria-label="Filtrar por facturación" [(ngModel)]="billingFilter" (change)="onFilterChange()">
                <option value="">Toda la facturación</option>
                <option value="mensual">mensual</option>
                <option value="anual">anual</option>
              </select>
            </div>
            <div class="form-group" style="flex:0 0 auto">
              <button type="button" class="btn btn-outline-secondary btn-sm" (click)="loadCircuits()">Actualizar</button>
            </div>
          </div>

          <div *ngIf="loading" class="text-center py-3">
            <div class="spinner-border" role="status"><span class="sr-only">Cargando…</span></div>
          </div>
          <div *ngIf="errorMsg" class="alert alert-danger mt-2" role="alert">{{errorMsg}}</div>
          <div *ngIf="!loading && circuits.length === 0 && !errorMsg" class="empty">No hay circuitos</div>

          <div class="table-responsive" *ngIf="!loading && circuits.length > 0">
            <table class="table table-sm table-striped table-bordered">
              <caption class="sr-only">Suscripciones de circuitos con estado, facturación y acciones</caption>
              <thead class="thead-dark">
                <tr>
                  <th scope="col">Circuito</th>
                  <th scope="col">Correo</th>
                  <th scope="col">Estado</th>
                  <th scope="col">Facturación</th>
                  <th scope="col">Medio de pago</th>
                  <th scope="col">Referencia</th>
                  <th scope="col">Último pago</th>
                  <th scope="col">Vence</th>
                  <th scope="col">Días restantes</th>
                  <th scope="col">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let c of circuits">
                  <td><small class="text-muted">{{c.guid}}</small></td>
                  <td>{{c.userEmail || '-'}}</td>
                  <td><span [ngClass]="getStatusClass(c.status)">{{c.status}}<span *ngIf="c.status === 'LIFETIME'"> grandfathered</span></span></td>
                  <td>{{c.billingCycle || '-'}}</td>
                  <td>{{c.paymentProvider || '-'}}</td>
                  <td>{{c.paymentReferenceMasked || '-'}}</td>
                  <td>{{formatDate(c.lastPaymentAt)}}</td>
                  <td>{{formatDate(c.subscriptionExpiresAt)}}</td>
                  <td>{{c.daysUntilExpiry !== null && c.daysUntilExpiry !== undefined ? c.daysUntilExpiry : '-'}}</td>
                  <td>
                    <div class="row-actions">
                      <button type="button" class="btn btn-info btn-sm" (click)="openHistory(c.guid, historyModal)">Historial</button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <ngb-pagination *ngIf="total > limit" [collectionSize]="total" [pageSize]="limit" [(page)]="page" (pageChange)="onPageChange($event)" [maxSize]="5" [boundaryLinks]="true" class="d-flex justify-content-center"></ngb-pagination>
          <div class="text-muted text-center small">Total: {{total}} — Página {{page}} de {{totalPages}}</div>
  </div>
</div>

<!-- Modal Historial -->
<ng-template #historyModal let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h5 class="modal-title text-truncate">Historial — {{historyGuid}}</h5>
    <button type="button" class="close" aria-label="Cerrar" (click)="d('Cross click')">&times;</button>
  </div>
  <div class="modal-body">
    <div *ngIf="loadingHistory" class="text-center py-3">
      <div class="spinner-border" role="status"><span class="sr-only">Cargando…</span></div>
    </div>
    <div *ngIf="!loadingHistory && historyEntries.length === 0" class="empty">No hay pagos</div>
    <div class="table-responsive" *ngIf="!loadingHistory && historyEntries.length > 0">
      <table class="table table-sm table-bordered">
        <caption class="sr-only">Pagos del circuito</caption>
        <thead>
          <tr>
            <th scope="col">ID</th>
            <th scope="col">Medio de pago</th>
            <th scope="col">Referencia</th>
            <th scope="col">Plan</th>
            <th scope="col">Monto</th>
            <th scope="col">Facturación</th>
            <th scope="col">Fecha</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let h of historyEntries">
            <td>{{h.id}}</td>
            <td>{{h.payment_provider || h.paymentProvider || '-'}}</td>
            <td>{{h.payment_reference || h.paymentReference || '-'}}</td>
            <td>{{h.plan_id || h.planId || '-'}}</td>
            <td>{{h.amount || '-'}} {{h.currency || ''}}</td>
            <td>{{h.billing_cycle || h.billingCycle || '-'}}</td>
            <td>{{formatDate(h.created_at || h.createdAt)}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <ngb-pagination *ngIf="historyTotal > historyLimit" [collectionSize]="historyTotal" [pageSize]="historyLimit" [(page)]="historyPage" (pageChange)="onHistoryPageChange($event)" [maxSize]="3" [boundaryLinks]="true" class="d-flex justify-content-center"></ngb-pagination>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" autofocus (click)="d('Close click')">Cerrar</button>
  </div>
</ng-template>



// WEBPACK FOOTER //
// ./src/app/system/maintainer/maintainer-console.component.html